import { Component } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import logo from '../../assets/images/logo_new.png';
import { ForgotUn, ForgotPw } from './components';

import { Box, AppBar, Toolbar, Grid } from '@mui/material';

class Forgot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showForgotPwd: false,
      showForgotUname: false
    };
  }

  componentDidMount() {
    const { pw } = this.props.match.params;

    if (pw) {
      this.setState({ showForgotPwd: true });
    } else {
      this.setState({ showForgotUname: true });
    }
  }

  render() {
    return (
      <Box sx={{ mb: 5 }}>
        <AppBar
          position="relative"
          sx={{
            background: 'transparent',
            boxShadow: 'none',
            py: 2.5
          }}>
          <Toolbar sx={{ p: 0 }}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
              <RouterLink to="/">
                <Box
                  component="img"
                  src={logo}
                  alt="Logo"
                  sx={{
                    width: {
                      xs: 125,
                      sm: 175
                    },
                    display: 'block'
                  }}
                />
              </RouterLink>
            </Box>
          </Toolbar>
        </AppBar>

        <Grid container>
          <Grid size={{ xs: 12, md: 12 }}>
            <Box
              sx={{
                width: '100%',
                mt: 4,
                px: {
                  xs: 2,
                  md: 4
                }
              }}>
              {this.state.showForgotPwd && <ForgotPw />}

              {this.state.showForgotUname && <ForgotUn />}
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

Forgot.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object.isRequired
};

export default withRouter(Forgot);
